import React, { useState } from "react";
import MainImages from "./MainImages";
import SubImages from "./SubImages";

function Gallery() {
    const [activeTab, setActiveTab] = useState("main"); // Default to "main" images

    return (
        <div className="w-full max-w-6xl mx-auto p-8 bg-white shadow-lg rounded-lg dark:bg-gray-800 dark:text-white">
            <h2 className="text-4xl font-semibold mb-6 text-center">Gallery</h2>
            
            {/* Button Group */}
            <div className="flex flex-col items-center">
                <div className="space-x-4 flex">
                    <button 
                        className={`px-4 py-2 rounded-md ${
                            activeTab === "main" ? "bg-purple-500" : "bg-gray-500"
                        } text-white`}
                        onClick={() => setActiveTab("main")}
                    >
                        Main Images
                    </button>
                    <button 
                        className={`px-4 py-2 rounded-md ${
                            activeTab === "sub" ? "bg-purple-500" : "bg-gray-500"
                        } text-white`}
                        onClick={() => setActiveTab("sub")}
                    >
                        Sub Images
                    </button>
                </div>
            </div>

            {/* Content Display */}
            <div className="mt-6">
                {activeTab === "main" && <MainImages />}
                {activeTab === "sub" && <SubImages />}
            </div>
        </div>
    );
}

export default Gallery;
